import { createSlice } from '@reduxjs/toolkit'
import {getDocumentationRequestTemplates} from "./thunks"
import { logOut } from '../authentication/authenticationSlice';
const initialState= {
    documentationRequestTemplates: [],
  loading: "idle",
  error: null }

const documentationRequestTemplatesSlice = createSlice({
  name: 'documentationRequestTemplates',
  initialState,
  reducers: {
    clearDocumentationRequestTemplatesError: (state)=>{
      state.error = null
      state.loading = "idle"
    }
  },
  extraReducers: {
    [getDocumentationRequestTemplates.pending]: (state) => {
        state.loading = "loading";
        state.error = null
      },
    [getDocumentationRequestTemplates.fulfilled]: (state, action) => {
    state.loading = "succeeded";
    state.documentationRequestTemplates = action.payload
    },
    [getDocumentationRequestTemplates.rejected]: (state, action) => {
        state.loading = "failed";
        state.error = action.error.message
      },
    [logOut]: (state)=> initialState
  }
})

export const {clearDocumentationRequestTemplatesError} = documentationRequestTemplatesSlice.actions;
export default documentationRequestTemplatesSlice.reducer